import type {
  Edge,
  Node,
} from 'react-flow-renderer';
import {
  isEdge,
  isNode,
} from 'react-flow-renderer';
import type {
  EdgeData,
  NodeData,
} from '../types';

type Elements = (Node<NodeData> | Edge<EdgeData>)[];


export const extractNodesFromElements = (
  elements: Elements,
): Node<NodeData>[] => elements.filter(isNode);
export const extractEdgesFromElements = (
  elements: Elements,
): Edge<EdgeData>[] => elements.filter(isEdge);

export const extractNodesAndEdgesFromElements = (elements: Elements) => {
  const nodes = extractNodesFromElements(elements);
  const edges = extractEdgesFromElements(elements);

  return {
    nodes,
    edges,
  };
};
